import { ComponentType } from "react";
import DirecitveEntryDiagnosticEntryCanceled from "../../../../pages/Show/components/tabs/ForwardingsTab/sections/DirectiveEntry/entries/DiagnosticEntry/status/Canceled";
import DirectiveEntryDiagnosticEntryOnGoingDirective from "../../../../pages/Show/components/tabs/ForwardingsTab/sections/DirectiveEntry/entries/DiagnosticEntry/status/OnGoingDirective";
import DirectiveEntryDiagnosticEntryOnGoingEstablishmentChoice from "../../../../pages/Show/components/tabs/ForwardingsTab/sections/DirectiveEntry/entries/DiagnosticEntry/status/OnGoingEstablishmentChoice";
import { MaintenanceForwardingStatus } from "../../../../types/forwardings/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../../../../types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import DirecitveEntryExecutionEntryCanceled from "../../../../pages/Show/components/tabs/ForwardingsTab/sections/DirectiveEntry/entries/ExecutionEntry/status/Canceled";
import DirectiveEntryExecutionEntryOnGoingFinancialReview from "../../../../pages/Show/components/tabs/ForwardingsTab/sections/DirectiveEntry/entries/ExecutionEntry/status/OnGoingFinancialReview";
import DirectiveEntryExecutionEntryOnGoingEstablishmentChoice from "../../../../pages/Show/components/tabs/ForwardingsTab/sections/DirectiveEntry/entries/ExecutionEntry/status/OnGoingEstablishmentChoice";
import DirectiveEntryExecutionEntryOnGoingDirective from "../../../../pages/Show/components/tabs/ForwardingsTab/sections/DirectiveEntry/entries/ExecutionEntry/status/OnGoingDirective";
import DirecitveEntryExecutionEntryCompleted from "../../../../pages/Show/components/tabs/ForwardingsTab/sections/DirectiveEntry/entries/ExecutionEntry/status/Completed";

export const maintenanceForwardingsDirectiveEntryStateStatus: Partial<{
  [K in MaintenanceForwardingsDirectiveEntryKlass]: {
    status: Partial<{
      [K in MaintenanceForwardingStatus]: {
        component: ComponentType;
      };
    }>
  }
}> = {
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: {
    status: {
      canceled: {
        component: DirecitveEntryDiagnosticEntryCanceled,
      },
      ongoing_directive: {
        component: DirectiveEntryDiagnosticEntryOnGoingDirective,
      },
      ongoing_establishment_choice: {
        component: DirectiveEntryDiagnosticEntryOnGoingEstablishmentChoice,
      },
    },
  },
  [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: {
    status: {
      canceled: {
        component: DirecitveEntryExecutionEntryCanceled,
      },
      completed: {
        component: DirecitveEntryExecutionEntryCompleted,
      },
      ongoing_directive: {
        component: DirectiveEntryExecutionEntryOnGoingDirective,
      },
      ongoing_establishment_choice: {
        component: DirectiveEntryExecutionEntryOnGoingEstablishmentChoice,
      },
      ongoing_financial_review: {
        component: DirectiveEntryExecutionEntryOnGoingFinancialReview,
      },
    },
  },
}
